import * as moment from 'moment';
export class InfoLogisticaDTO {
    public Nota: string;
    public Serie: string;
    public Emissao: Date;
    public Pedido: string;
    public PrePedido: string;
    public Cliente: string;
    public Transportadora: string;
    public Cidade: string;
    public Uf: string;
    public Peso: string;
    public Volume: string;
    public Previsao: Date;
    public Expedicao: Date;
    public Entrega: Date;
    public Agendamento: Date;
    public Observacao: string;

    public get Municipio() : string {
        return `${this.Cidade}/${this.Uf}`;
    }

    /**
     *
     */
    constructor(data: any = {}) {

        const dateFormat = "YYYYMMDD";

        this.Nota = data.NOTA;
        this.Serie = data.SERIE;
        this.Emissao = data.EMISSAO && moment(data.EMISSAO,dateFormat).toDate();
        this.Pedido = data.PEDIDO;
        this.PrePedido = data.PREPEDIDO;
        this.Cliente = data.CLIENTE;
        this.Transportadora = data.TRANSPORTADORA;
        this.Observacao = data.OBSERVACAO;
        this.Cidade = data.CIDADE;
        this.Uf = data.UF;
        this.Peso = data.PESO;
        this.Volume = data.VOLUME;
        this.Previsao = data.PREVISAO && moment(data.PREVISAO,dateFormat).toDate() ;
        this.Expedicao = data.EXPEDICAO && moment(data.EXPEDICAO,dateFormat).toDate();
        this.Entrega = data.ENTREGA && moment(data.ENTREGA,dateFormat).toDate();
        this.Agendamento = data.AGENDAMENTO && moment(data.AGENDAMENTO,dateFormat).toDate();

    }
}